import React from 'react';
import {
  Calendar as BasePlainCalendar,
  CalendarProps,
} from 'react-native-plain-calendar';

import { CalendarDay } from './CalendarDay';
import { CalendarHeader } from './CalendarHeader';
import { CalendarWeekdays } from './CalendarWeekdays';

export interface ICalendarProps extends Partial<CalendarProps> {}

export function Calendar(props: ICalendarProps) {
  return (
    <BasePlainCalendar
      DayComponent={CalendarDay}
      HeaderComponent={CalendarHeader}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore react-native-plain-calendar has some issues with types
      WeekdaysComponent={CalendarWeekdays}
      {...props}
    />
  );
}
